const MODULE_ID = 'fiatRampApi'

const fiatRampApi = ({ fiatRamp, fiatOrders }) => ({
  fiatRamp: {
    addOrderEvent: fiatRamp.addOrderEvent,
    createOrder: fiatRamp.createOrder,
    createOrderDeposit: fiatRamp.createOrderDeposit,
    fetchAssets: fiatRamp.fetchAssets,
    getAssetsByPaymentMethod: fiatRamp.getAssetsByPaymentMethod,
    getOrder: fiatRamp.getOrder,
    getPaymentMethods: fiatRamp.getPaymentMethods,
    getProvider: fiatRamp.getProvider,
    getProviderEnabled: fiatRamp.getProviderEnabled,
    getQuotes: fiatRamp.getQuotes,
    getServerUrl: fiatRamp.getServerUrl,
    getToken: fiatRamp.getToken,
    getWidgetUrl: fiatRamp.getWidgetUrl,
    hideFailedOrderNotification: fiatRamp.hideFailedOrderNotification,
    syncOrder: fiatOrders.sync,
    updateAssets: fiatRamp.fetchAssets, // TODO: Remove me in next major version
  },
})

const fiatRampApiDefinition = {
  id: MODULE_ID,
  type: 'api',
  factory: fiatRampApi,
  dependencies: ['fiatRamp', 'fiatOrders'],
}

export default fiatRampApiDefinition
